import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const re_uploadScromApi = createAsyncThunk(
  "scrom_upload/upload",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.patch(apiRoutes.courseScormAction(`${data.course_id}`, 0), data.file, { headers: { "Content-Type": "multipart/form-data" } })
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }
const updateScromSlice = createSlice({
  name: "scrom_upload",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetImage: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(re_uploadScromApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(re_uploadScromApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(re_uploadScromApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetImage } = updateScromSlice.actions;
export const uploadScromReducer = updateScromSlice.reducer;
